import { SignIn } from "../pages/Auth/Signin";
import { Books } from "../pages/Books";
import Permissions from "./permissions";
import { ServerError } from "../pages/Auth/ServerError";
import { NotFound } from "../pages/Auth/NotFound";
import { BooksCategory } from "../pages/BooksCategory";
import { BookDetail } from "../pages/BookDetail";
import { CategoryBooks } from "../pages/CategoryBooks";
import { Thoughts } from "../pages/Thoughts";

export const Routess = {
    // Auth
    Login: { path: "/login", permission: null, component: <SignIn /> },
    NotFound: { path: "/not-found", permission: null, component: <NotFound /> },
    ServerError: { path: "/server", permission: null, component: <ServerError /> },

    Home: { path: "/", permission: null, component: <Books /> },
    DashboardOverview: { path: "/dashboard", permission: null, component: <Books /> },
    Books: { path: "/books", permission: null, component: <Books /> },
    Thoughts: { path: "/thoughts", permission: null, component: <Thoughts /> },
    BooksView: { path: "/books/:id", permission: null, component: <BookDetail /> },
    BooksCategory: { path: "/books-category", permission: null, component: <BooksCategory /> },
    BooksCategoryBooks: { path: "/books-category/:id", permission: null, component: <CategoryBooks /> },
};